import RequiresAuth from '@website/components/auth/RequiresAuth';
import Inbox from '@website/components/chat/Inbox';
import { CustomerDashboardLayout } from '@website/components/me/userID/CustomerDashboardLayout';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { useRouter } from 'next/router';

export default function CustomerInbox() {
  const { query } = useRouter();
  if (!query.userID) return <LoadingPage />;

  return (
    <RequiresAuth>
      <CustomerDashboardLayout
        activeTab="Messages"
        userID={query.userID as string}
        hideAlerts
      >
        <Inbox userID={query.userID as string} />
      </CustomerDashboardLayout>
    </RequiresAuth>
  );
}
